import React from 'react';
import AnalyticsTeam from './AnalyticsTeam/AnalyticsTeam';

const RecruiterPerformance = ({ isRTL = false, companyUID = '', analyticsActorId = 'system' }) => (
  <AnalyticsTeam isRTL={isRTL} companyUID={companyUID} analyticsActorId={analyticsActorId} />
);

export default RecruiterPerformance;
